import { ISalaryScaleGroup, SalaryScaleGroupService } from '../../../services/salaryScaleGroup.service';
import { ISalaryScale, SalaryScaleService } from '../../../services/salaryScaleGroup.service';
import * as angular from 'angular';

class SalaryScaleListController {
    private salaryScaleGroups: ISalaryScaleGroup[];
    private selectedGroup: ISalaryScaleGroup;
    private search: string;
    private currentSalaryScale: ISalaryScale;
    
    constructor(
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private SalaryScaleService: SalaryScaleService
    ) {
        "ngInject";
    }

    public $onInit = () => {
        this.loadSalaryScaleGroups();
    }

    private loadSalaryScaleGroups = () => {
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            // Sorteer alfabetisch op naam
            this.salaryScaleGroups = result.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
            
            // Haal salary scales op voor elke groep
            this.salaryScaleGroups.forEach(group => {
                if (group.id) {
                    this.SalaryScaleService.getBySalaryScaleGroupId(group.id).then((scales: ISalaryScale[]) => {
                        group.salaryScales = scales;
                    });
                }
            });
            
            // Update selectedGroup als die nog bestaat
            if (this.selectedGroup) {
                const updatedGroup = this.salaryScaleGroups.find(g => g.id === this.selectedGroup.id);
                if (updatedGroup) {
                    this.selectedGroup = updatedGroup;
                }
            }
        });
    }

    public clearSelection = () => {
        this.selectedGroup = null;
    }

    public onGroupChange = (selectedGroup: ISalaryScaleGroup) => {
        this.selectedGroup = selectedGroup;
    }

    public openAddScaleModal = () => {
        if (!this.selectedGroup || !this.selectedGroup.id) {
            alert('Geen CAO geselecteerd. Selecteer eerst een CAO om een loonschaal toe te voegen.');
            return;
        }

        this.currentSalaryScale = {
            id: undefined,
            salaryScaleGroupId: this.selectedGroup.id,
            code: '',
            name: '',
            hourlyWage: 0,
            conversionFactor: 0
        } as ISalaryScale;

        (<any>$('#salaryScaleModal')).modal('show');
    }

    public openEditScaleModal = (scale: ISalaryScale) => {
        this.currentSalaryScale = angular.copy(scale);
        (<any>$('#salaryScaleModal')).modal('show');
    }

    public submitSalaryScale = () => {
        if (this.currentSalaryScale.id === undefined) {
            this.SalaryScaleService.post(this.currentSalaryScale).then((result: any) => {
                (<any>$('#salaryScaleModal')).modal('hide');
                this.loadSalaryScaleGroups();
            });
        } else {
            this.SalaryScaleService.put(this.currentSalaryScale.id, this.currentSalaryScale).then(result => {
                (<any>$('#salaryScaleModal')).modal('hide');
                this.loadSalaryScaleGroups();
            });
        }
    }

    public deleteSalaryScale = () => {
        if (confirm('Weet je zeker dat je deze loonschaal wilt verwijderen?')) {
            this.SalaryScaleService.delete(this.currentSalaryScale.id).then((result: any) => {
                (<any>$('#salaryScaleModal')).modal('hide');
                this.loadSalaryScaleGroups();
            });
        }
    }
}

export const salaryScaleListComponent = {
    controller: SalaryScaleListController,
    template: require("./salaryScale.list.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/salaryScales/salaryScale.list.component.ts